import React, { useState, useEffect } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { useHistory, useLocation } from "react-router-dom";

const CurrentInjury6 = () => {
  const history = useHistory();
  const location = useLocation();
  const [totalSymptoms, setTotalSymptoms] = useState(0);
  const [severityScore, setSeverityScore] = useState(0);

  const previousValues = location.state?.previousValues || {};
  console.log("previousValues : ", previousValues);

  const initialValues = {
    totalNoSymptoms: totalSymptoms,
    symptomsSeverityScore: severityScore,
    worsePhysical: "Yes",
    worseMental: "Yes",
    normalPercentage: 0,
    explanation: "",
  };

  useEffect(() => {
    let totalSymptomsCount = 0;
    let totalScore = 0;

    Object.values(previousValues).forEach((value) => {
      if (value !== 0) {
        totalSymptomsCount++;
        totalScore += value;
      }
    });

    setTotalSymptoms(totalSymptomsCount);
    setSeverityScore(totalScore);
  }, [previousValues]);

  const handleSubmit = (values) => {
    console.log("Form Values:", values);
    history.push("/concussion-forms");
  };

  return (
    <div className="form-container">
      <div className="form-header">
        <span className="form-title">Current Injury</span>
        <span className="form-progress">12/12</span>
      </div>

      <Formik initialValues={initialValues} onSubmit={handleSubmit}>
        {({ isSubmitting, values, setFieldValue }) => (
          <Form className="form-wrapper">
            <div className="form-content">
              <div className="field-wrapper">
                <label className="field-label">
                  Total Number of Symptoms:{" "}
                  <span className="score-label">
                    {totalSymptoms}/22&nbsp;&nbsp; (
                    {((totalSymptoms / 22) * 100).toFixed(1)}%)
                  </span>
                </label>
                <label className="field-label">
                  Symptom Severity Score:{" "}
                  <span className="score-label1">
                    {severityScore}/132 (
                    {((severityScore / 132) * 100).toFixed(1)}%)
                  </span>
                </label>
              </div>
              <div className="field-wrapper">
                <label className="field-label">
                  Do your symptoms get worse with physical activity?
                </label>
                <div role="group" className="tabs-group">
                  {["Yes", "No"].map((option) => (
                    <Field name="worsePhysical">
                      {({ field, form }) => (
                        <p
                          className={`tab  ${
                            field.value === option ? "active" : ""
                          }`}
                          onClick={() =>
                            form.setFieldValue("worsePhysical", option)
                          }
                        >
                          {option}
                        </p>
                      )}
                    </Field>
                  ))}
                </div>
                <ErrorMessage
                  name="worsePhysical"
                  component="div"
                  className="error-message"
                />
              </div>

              <div className="field-wrapper">
                <label className="field-label">
                  Do your symptoms get worse with mental activity?
                </label>
                <div role="group" className="tabs-group">
                  {["Yes", "No"].map((option) => (
                    <Field name="worseMental">
                      {({ field, form }) => (
                        <p
                          className={`tab  ${
                            field.value === option ? "active" : ""
                          }`}
                          onClick={() =>
                            form.setFieldValue("worseMental", option)
                          }
                        >
                          {option}
                        </p>
                      )}
                    </Field>
                  ))}
                </div>
                <ErrorMessage
                  name="worseMental"
                  component="div"
                  className="error-message"
                />
              </div>

              <div className="field-wrapper">
                <label className="field-label">
                  If 100% is feeling perfectly normal, what percent of normal do
                  you feel?
                </label>
                <div className="slider-container">
                  <input
                    type="range"
                    name="normalPercentage"
                    min="0"
                    max="100"
                    step="1"
                    value={values.normalPercentage}
                    onChange={(e) =>
                      setFieldValue("normalPercentage", e.target.value)
                    }
                    className="field-input"
                  />
                  <span className="slider-percentage">
                    {values.normalPercentage}%
                  </span>{" "}
                </div>
                <ErrorMessage
                  name="normalPercentage"
                  component="div"
                  className="error-message"
                />
              </div>

              <div className="field-wrapper">
                <label className="field-label">Please explain.</label>
                <Field
                  name="explanation"
                  className="field-input notes"
                  as="textarea"
                />
                <ErrorMessage
                  name="explanation"
                  component="div"
                  className="error-message"
                />
              </div>
            </div>

            <div className="btn-wrapper">
              <button
                type="button"
                className="form-btns back-btn"
                disabled={isSubmitting}
                onClick={() => history.goBack()}
              >
                BACK
              </button>
              <button
                type="submit"
                className="form-btns next-btn"
                disabled={isSubmitting}
              >
                FINISH
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default CurrentInjury6;
